import { GraphData, GraphEdge, GraphVertex } from '../types';

export const dedupeVertices = (
  newVertices: GraphVertex[],
  allVertices: GraphVertex[]
) => newVertices.filter((v) => !allVertices.find((a) => a.id === v.id));

export const dedupeEdges = (newEdges: GraphEdge[], allEdges: GraphEdge[]) =>
  newEdges.filter(
    (e: GraphEdge) =>
      !allEdges.find(
        (a) =>
          a.fromVertexId === e.fromVertexId && a.toVertexId === e.toVertexId
      )
  );

export const dedupeEdgesAndVertices = (
  newData: GraphData,
  allData: GraphData
) => ({
  vertices: dedupeVertices(newData.vertices, allData.vertices),
  edges: dedupeEdges(newData.edges, allData.edges),
});
